import Vue from 'vue';
import { apigw, axios } from './http.js';
import { Toast } from '@zyf2e/capui-mobile';
// import util from '../util';
Vue.use(Toast);

const MOCK_API = '';
const MOCK_API1 = '';
const test = ``;
const order = '';

let Fetch = {
  // 新的通用上传接口
  uploadFile(params) {
    return apigw.post(`${MOCK_API}/file/1.0/upload`, params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // 医道上传文件网关接口
  uploadFileGw(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0/upload_file`, params);
  },

  // 上传资料 获取用户初始选择
  fetchGetFileInformation(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0/advisory_get_again_info`, params);
  },
  // 资料提交接口
  submitFileInformation(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0/advisory_submit_again_info`, params);
  },
  // 院外药品流转接口
  // 获取药品类目
  fetchCategory() {
    return apigw.get(`${MOCK_API}/medicsale/4.0/drug_category`, {});
  },
  // 获取药品类目
  fetchGoodsCategory() {
    return apigw.get(`${MOCK_API}/medicsale/4.1.1/not_drug_category`, {});
  },
  fetchProductList(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0/item_list`, params, { loading: true });
  },
  // 获取需求清单数量
  fetchCountTrolley() {
    return apigw.get(`${MOCK_API}/medicsale/4.0/medicsale_count_trolley`, {});
  },
  // 单个商品加入购物车
  addOneTrolley(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0/medicsale_add_one_trolley`, params);
  },
  // 获取购物车列表接口
  fetchCartList(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0/medicsale_trolley`, params, { loading: true });
  },
  // 删除购物车
  deleteTrolley(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0/medicsale_delete_trolley_by_item_id`, params, { loading: false });
  },
  // 添加购物车
  addTrolley(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0/medicsale_add_trolley`, params, { loading: true });
  },
  // 获取包邮信息 /medicsale/4.0.5/get_express_free
  fetchExpressFree(params) {
    return apigw.get(`${MOCK_API}/hy-mall/1.0/get_free_shippingfee`, params, { loading: false });
  },
  // 获取处方列表接口
  getRecipeList(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0/prescription_list`, params, { loading: true });
  },
  // 获取处方下载URL
  getRecipeDownUrl(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0/get_prescription_image_url`, params, { loading: false });
  },
  // 提交购物车 /medicsale/4.0/submit_trolley
  submitTrolley(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0/medicsale_submit_trolley`, params, { loading: true });
  },
  // 查看药品详情
  getItemDetail(params) {
    return apigw.get(`${MOCK_API1}/medicsale/4.0/drug_detail`, params, { loading: true });
  },
  // 获取单个商品的 amount 和 库存
  getItemMun(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0/medicsale_get_item_info`, params);
  },

  // 院内处方流转1.0新增接口
  getWxConfig() {
    return apigw.get('/medicsale_patient/1.0/share_config', { url: location.href });
  },
  getMobileCode(params) {
    return apigw.post('medicsale_patient/1.0/send_verify_code', params);
  },
  getBasicInfo: () => {
    return apigw.get('medicsale/4.0.5/get_user_info', {});
  },
  bindUserInfo: (data) => {
    return apigw.post('medicsale/4.0/user_save_bind', data);
  },

  // 根据 经纬度 获取具体的详细地址信息
  // getUserLocation: (data) => {
  //   return apigw.get('medicsale/4.0/get_user_location', data);
  // },
  updMobile: (params) => {
    return apigw.post('medicsale_patient/1.0/modify_mobile', params).then((data) => {
      if (data.code == -101 || data.code == -103) {
        Toast(data.message);
      }
      return data;
    });
  },

  getBindingDoctors: (param = { pageNo: null, pageSize: null, sort: 0 }) => {
    return apigw.post('medicsale/1.0/prescription_doctor_list', param, { loading: true });
  },
  getDoctorDetail(doctorId) {
    return apigw.get('medicsale/1.0/doctor_detail', { doctorId }, { loading: true });
  },
  consultDoctor: (params) => {
    return apigw.get('medicsale/1.0/user_advisory', params);
  },

  // 处方相关，商城相关接口
  getPreRxConfig(params) {
    return apigw.get('mall-portal/1.0/global_config', params);
  },
  getRecipeDetail(id) {
    return apigw.get('/medicsale/4.0.5/get_prescription_detail', { id });
    // return apigw.get('prescription/1.0/detail', { id });
  },

  // 修改订单收货地址
  changeOrderAddress(params) {
    // 获取与门店相距位置
    return apigw.post(test + `/hy-mall/1.0/change_order_address`, params);
  },
  // // 地址相关
  // queryStoreDistance(params) {
  //   // 获取与门店相距位置
  //   return apigw.post(test + `/hy-mall/1.0/calculate_supplier_distance`, params);
  // },
  getOrderList: (params) => {
    return mallRequest.get('orders', params);
  },
  // 订单详情
  // getOrderDetail: (id, params) => {
  //   return mallRequest.get(`orders/${id}`, params);
  // },
  // 获取物流信息详情
  fetchExpressStatusDetail(params) {
    return mallRequest.get(`/orders/express/${params.orderId}`);
  },
  // 下单
  submitOrder(order) {
    return mallRequest.post('orders', order);
  },

  // mengkun说供应链二期（订单模块）再用这两个接口，一期用老的
  // 地址相关
  queryStoreDistance(params) {
    // 获取与门店相距位置
    return apigw.post(`/hy-mall/1.0/calculate_supplier_distance`, params);
  },
  // 获取默认收货地址
  getDefaultAddress(params) {
    return apigw.get(test + `/hy-mall/1.0/user_default_address`, params);
  },

  getAddressList(params) {
    return apigw.get(test + '/hy-mall/1.0/user_addresses', params);
  },
  addAddressAction(params) {
    // 新增地址
    return apigw.post(test + '/hy-mall/1.0/add_address', { ...params });
  },
  updateAddressAction(params) {
    // 更新地址
    return apigw.post(test + '/hy-mall/1.0/edit_address', { ...params });
  },
  deleteAddressAction(params) {
    // 删除地址
    return apigw.post(test + '/hy-mall/1.0/delete_address', { ...params });
  },
  // 根据 经纬度 获取具体的详细地址信息
  getUserLocation: (data) => {
    return apigw.get('/hy-mall/1.0/get_location_detail', data);
  },
  // 获取省市区列表
  getAllAreaList() {
    return apigw.get(`/hy-mall/1.0/get_areas_tree`);
  },
  // 删除收货地址
  deleteAddress: (id) => {
    return mallRequest.delete(`addresses/${id}`);
  },
  // 立即咨询V2
  fetchAdvisory(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0/medicsale_advisory_v2`, params, { loading: true });
  },
  // 创建tradeNo
  fetchCreateTradeNo(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0/medicsale_create_advisory`, params);
  },
  // 判断是否是父订单
  fetchIsFatherOrder(params) {
    return apigw.get(`${MOCK_API}/hy-mall/1.0/judge_order_parent`, params);
  },
  // 查询咨询状态
  fetchGetAdvisoryStatus(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0/get_advisory_info`, { ...params }, { loading: true });
  },
  // 病历本列表
  fetchGetMedicalMember(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0.5/medical_member`, { ...params }, { loading: true });
  },
  // 就诊人病历列表
  fetchGetMedicalRecord(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0.5/medical_record`, { ...params });
  },
  // 就诊人病历详情
  fetchGetMedicalRecordDetail(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0.5/medical_record_detail`, { ...params }, { loading: true });
  },
  // 获取最早年份
  fetchGetFirstRecordYear(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0.5/get_first_record_year`, { ...params }, { loading: true });
  },
  // 修改昵称
  fetchModifyUserInfo(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0.5/modify_user_info`, params);
  },

  // 订单列表
  fetchGetOrderList(params) {
    return apigw.get(`${MOCK_API1}/hy-mall/1.0/my_order`, params, { loading: false });
    // return apigw.get(`${MOCK_API}/mall-portal/1.0/getParentOrderList`, params, { loading: false });
  },
  // 或取订单徽标数量
  fetchOrderBudget(params) {
    return apigw.get(`${MOCK_API1}/hy-mall/1.0/order_count`, params, { loading: false });
  },

  //  商品推荐单相关接口
  // 根据需求清单查询要跳转页面 /medicsdale/4.0.5/go_url_settlement
  fetchGetSettlementStatus(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0.5/go_url_settlement`, { ...params }, { loading: false });
  },
  // 根据 推荐单Id 查询跳转页面接口
  fetchGetRecommendStatus(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0.5/go_url`, { ...params }, { loading: false });
  },
  // 根据推荐单id 查询相关商品信息
  fetchGetRecommendList(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0.5/get_recommend_info`, { ...params }, { loading: true });
  },
  // 提交推荐单
  fetchSubmitRecommendList(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0.5/commit_recommend`, { ...params }, { loading: true });
  },
  // 根据需求清单Id 查询相关内容
  fetchGetSettlementList(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.0.5/query_settlement_info`, { ...params }, { loading: true });
  },
  // 用户自主购买非药品通过后下单
  fetchSubmitSettlementList(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.0.5/go_mall_pre_order`, { ...params }, { loading: true });
  },
  // 获取tradeNo
  fetchGetTradeNo(params) {
    return apigw.post(`${MOCK_API}/hy-mall/1.0/create_trade`, { ...params }, { loading: true });
  },

  // 退款
  postApplyRefund(params) {
    return apigw.post('/mall-portal/1.0/apply_refund', { ...params });
  },
  getRefundDetail(params) {
    return apigw.get('/mall-portal/1.0/refund_detail', params);
  },
  addExpressInfo(params) {
    return apigw.post('/mall-portal/1.0/add_express_info', { ...params });
  },

  // 订单
  postExpressConfirm(params) {
    // 确认收货
    return apigw.post('/mall-portal/1.0/order_express_confirm', { ...params });
  },
  cancelOrder(params) {
    // 取消订单
    return apigw.post(`/mall-portal/1.0/cancel_order`, { ...params });
  },
  endOrder(params) {
    return apigw.get(`/mall-portal/1.0/end_order`, params);
  },
  // 再来一单查询
  toBuyAgain(params) {
    return apigw.get(test + `/hy-mall/1.0/get_one_more_order`, params);
  },
  // 再来一单涉及批量加入购物车
  batchAddCart(params) {
    return apigw.post(test + `/medicsale/chain1.0/medicsale_add_trolley_batch`, { ...params });
  },
  getOrderExpressList(params) {
    return apigw.get(test + `/hy-mall/1.0/get_order_logistics`, params);
  },

  // 院外预下单
  postPreOrder(params) {
    return apigw.post(`/hy-mall/1.0/commit_pre_order`, { ...params });
  },

  // 根据处方id 获取订单列表
  getItemsByRxId(params) {
    return apigw.get(`/mall-portal/2.0/getItemsByRxId`, params);
  },
  // 代付前调用
  postThirdPayPre(params) {
    return apigw.post(`/hy-mall/1.0/create_replace_trade`, { ...params });
  },
  // 代付相关
  queryReplacePayInfo(params) {
    return apigw.get(`/hy-mall/1.0/get_replace_tradeInfo`, params);
  },
  itemReplacePayVisible(params) {
    // 商品信息是否用户可见
    return apigw.post(`/mall-portal/1.0/update_replace_pay_info_item_visible`, {
      ...params
    });
  },

  // 2.0新下单相关
  commitOrder(params) {
    return apigw.post(
      '/hy-mall/1.0/commit_order',
      {
        ...params
      },
      { loading: true }
    );
  },

  // 问诊相关
  // 智云医道 获取tradeno 接口
  getPayAdvisoryTradeNo(params) {
    return apigw.post('/medicsale/4.0/medicsale_create_advisory', params);
  },
  // 智云医道 取消订单的接口
  postCancelOrder(params) {
    return apigw.post('/hy-mall/1.0/cancel_order', params);
  },
  // 智云医道  取消问诊订单
  postCancelAdvisory(params) {
    return apigw.post('/medicsale/4.0/cancel_advisory', params);
  },
  uploadImg(params) {
    return apigw.post('/spider-fileupload/1.0/upload', params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  refundUpdateExpressWay(params) {
    return apigw.post('/mall-portal/1.0/refund_update_express_way', params);
  },
  // 查询是否风险区域
  submitMedicasalePreOrder(params) {
    return apigw.get('/hy-mall/1.0/get_scene_content', params, { loading: true });
  },

  // 优惠券
  getCouponList(params) {
    // 优惠券列表
    return apigw.get('/medicsale/chain1.0/page_coupon_list', params);
  },
  getCouponListByItem(params) {
    // 获取商品可用的优惠券商品列表
    return apigw.get('/medicsale/chain1.0/page_coupon_item_list', params);
  },
  getCanUseCouponList(params) {
    // 获取该订单可用的优惠券
    return apigw.post('/hy-mall/1.0/page_coupon_group', params, { loading: true });
    // return apigw.post('/medicsale/4.1.1/page_coupon_group', params, { loading: true });
  },
  receiveCoupon(params) {
    // 领取优惠券
    return apigw.post('/medicsale/chain1.0/receive_coupon', params);
  },
  getItemListByCoupon(params) {
    // 搜索商品列表
    return apigw.get('/medicsale/chain1.0/item_list_by_coupon', params);
  },
  confirmUseCoupon(params) {
    return apigw.post('/hy-mall/1.0/order_optimal_coupon', params);
    // return apigw.post('/medicsale/4.1.1/choose_optimal_coupon', params);
  },
  checkOrderItem(params) {
    return apigw.get('/hy-mall/1.0/check_order_item', params);
  },

  // 注销账号验证
  logOffPreCheck(params) {
    return apigw.get('/medicsale_patient/1.0/logoff_precheck', params);
  },
  logOffAccount(params) {
    return apigw.post('/medicsale_patient/1.0/logoff', params);
  },

  // 供应链订单接口
  getSupplyOrderDetail(params) {
    return apigw.get('/hy-mall/1.0/order_detail', params);
  },

  // 供应链退款接口
  getSupplyOrderRefundDetail(params) {
    return apigw.get('/hy-mall/1.0/refund_detail', params);
  },
  // 退款单列表
  getSupplyRefundListByGoods(params) {
    return apigw.get('/hy-mall/1.0/refund_list_by_goods', params);
  },
  // 获取可退款商品
  getRefundGoodsInOrder(params) {
    return apigw.get('/hy-mall/1.0/get_can_refund_items_info', params);
  },

  // 申请退款原因
  getSupplyRefundReason(params) {
    return apigw.get('/hy-mall/1.0/get_refund_reason', params);
  },
  // 获取退款金额
  getGoodsRefundAmount(params) {
    return apigw.post('/hy-mall/1.0/get_refund_amount', params);
  },
  // 是否可以退款
  checkOrderCanRefund(params) {
    return apigw.get('/hy-mall/1.0/can_refund', params);
  },

  // 申请退款
  supplyApplyRefund(params) {
    return apigw.post('/hy-mall/1.0/apply_refund', params);
  },
  // 取消退款单
  cancelSupplyRefund(params) {
    return apigw.get('/hy-mall/1.0/close_refund_order', params);
  },
  // 用户自行送回
  returnBySelfRefund(params) {
    return apigw.get('/hy-mall/1.0/return_by_self', params);
  },
  // 获取快递公司
  getExpressCompanyList(params) {
    return apigw.get('/hy-mall/1.0/get_express_company', params);
  },
  // 确认收货
  confirmSupplyOrder(params) {
    return apigw.post('/hy-mall/1.0/express_confirm', params);
  },

  // 上传快递公司
  uploadExpressInfo(params) {
    return apigw.post('/hy-mall/1.0/upload_express_Info', params);
  },
  // 供应链商城化
  getMallResourceStateList(params) {
    return apigw.post(`${MOCK_API}/medicsale/4.3.0/get_mall_resource_state_list`, params);
  },
  // 根据资源ID获取
  getItemListByResourceId(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.3.0/resource_item_list`, params);
  },
  // 联想词列表
  searchKeywordsList(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.3.0/search_key_list`, params);
  },
  searchItemListByKeyword(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.3.0/search_item_list`, params);
  },
  getCompanyList(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.3.0/get_manufacturer_list`, params);
  },
  // 商品code 查询
  getItemListByCode(params) {
    return apigw.get(`${MOCK_API}/medicsale/4.3.0/query_item_by_code`, params);
  },

  getCartCountTrolley(params) {
    return apigw.get('/medicsale/4.0/medicsale_count_trolley', params);
  },
  // 获取发票信息
  getInvoiceDetail(params) {
    return apigw.get(`${MOCK_API}/scs-gateway/1.0.0/get_invoice_by_sourceOrderSn`, params);
  },
  // 查询模板消息详情
  getMessageDetail(params) {
    return apigw.get('/medicsale/4.3.0/get_rich_text_detail', params);
  },
  // 查询dms配置的处方药蒙层信息
  getRxShadeConfig() {
    return axios.get('https://static.91jkys.com/dms/0b72af7240a88eaf1da093e42bac21ff.json');
  },
  // 预问诊
  preAdvisory (params) {
    return apigw.post(`${MOCK_API}/medicsale/4.3.0/pre_advisory`, params);
  },
  // 保存疾病描述
  saveDiseaseDesc (params) {
    return apigw.post(`${MOCK_API}/medicsale/4.3.0/save_disease_desc`, params);
  },
  
  // 催促发货
  urgeOrder(params) {
    return apigw.post(`${MOCK_API}/hy-mall/1.0/deliver_alert`, params);
  },

  useIllnessHistory (data) {
    return axios.post('guidance/3.0/use_illness_history', {
      ...data,
    });
  },
  
  // 健康计划列表
  fetchPostApiPatientHealthHealthPlanList(params) {
    return apigw.get(`medicsale/4.3.0/query_health_plan_list`, params);
  },
  
  // 健康计划详情
  fetchGetApiPatientHealthHealthPlanDetail(params) {
    return apigw.get(`medicsale/4.3.0/get_health_plan_detail`, params);
  },
  
  // 加入健康计划
  fetchGetApiPatientHealthHealthAcceptPlan(params) {
    return apigw.post(`medicsale/4.3.0/join_health_plan`, params);
  },

  // 答卷详情
  fetchGetQuestionnaireResult(params) {
    return apigw.get(`medicsale/4.3.0/query_answered_questionnaire`, params);
  },

  // 问卷详情
  fetchGetQuestionnaire(params) {
    return apigw.get(`medicsale/4.3.0/query_questionnaire_detail`, params);
  },
  
  // 提交答卷
  fetchPostQuestionnaireSubmit(params) {
    return apigw.post(`medicsale/4.3.0/commit_questionnaire`, params);
  },
};

export default Fetch;
window.Fetch = Fetch;
